module.exports = __webpack_public_path__ + "static/media/product_adventure_icon.fbecdfa2.svg";